/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon64Regular = forwardRef('ArrowADownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M30.5 54.258V8a1.5 1.5 0 0 1 3 0v46.258a4.483 4.483 0 0 0 1.682-1.061l16.757-16.758a1.5 1.5 0 0 1 2.122 2.122L37.303 55.318a7.5 7.5 0 0 1-10.606 0L9.939 38.561a1.5 1.5 0 1 1 2.122-2.122l16.757 16.758a4.483 4.483 0 0 0 1.682 1.061Z" })));
});
